'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var xyParser = require('xy-parser');
var xyConvert = _interopDefault(require('ml-xy-convert'));

/**
 * Parse from a xyxy data array
 * @param {Array<Array<number>>} data - xyxy array of data
 * @param {object} [meta] - same metadata object format that the convertToJcamp
 * @return {string} JCAMP of the input
 */
function creator(data, meta = {}) {
  const {
    title = '',
    owner = '',
    origin = '',
    type = '',
    xUnit = '',
    yUnit = '',
    info = {}
  } = meta;
  let firstX = Number.MAX_VALUE;
  let lastX = Number.MIN_VALUE;
  let firstY = Number.MAX_VALUE;
  let lastY = Number.MIN_VALUE;
  var points = [];

  for (var i = 0; i < data.length; i++) {
    if (data[i].length > 1) {
      var x = Number(data[i][0]);
      var y = Number(data[i][1]);
      if (firstX > x) {
        firstX = x;
      }
      if (lastX < x) {
        lastX = x;
      }
      if (firstY > y) {
        firstY = y;
      }
      if (lastY < y) {
        lastY = y;
      }
    }
    points.push(`${x} ${y}`);
  }

  var header = `##TITLE=${title}
##JCAMP-DX=4.24
##DATA TYPE=${type}
##ORIGIN=${origin}
##OWNER=${owner}
##XUNITS=${xUnit}
##YUNITS=${yUnit}
##FIRSTX=${firstX}
##LASTX=${lastX}
##FIRSTY=${firstY}
##LASTY=${lastY}\n`;

  for (const key of Object.keys(info)) {
    header += `##$${key}=${info[key]}\n`;
  }

  // we leave the header and utf8 fonts ${header.replace(/[^\t\r\n\x20-\x7F]/g, '')

  return `${header}##NPOINTS=${points.length}
##PEAK TABLE=(XY..XY)
${points.join('\n')}
##END`;
}

/**
 * Convert strings into JCAMP and add extra information
 * @param {string} data - values to add to the file, usually a csv or tsv values
 * @param {object} [options={}]
 * @param {string} [options.meta] - metadata of the file
 * @param {string} [options.meta.title = ''] - title of the file
 * @param {string} [options.meta.owner = ''] - owner of the file
 * @param {string} [options.meta.origin = ''] - origin of the file
 * @param {string} [options.meta.type = ''] - type of data
 * @param {string} [options.meta.xUnit = ''] - units for the x axis
 * @param {string} [options.meta.yUnit = ''] - units for the y axis
 * @param {object} [options.meta.info = {}] - comments to add to the file
 * @param {object} [options.parser = {}] - 'xy-parser' options. arrayType = 'xyxy' is enforced
 * @return {string} JCAMP of the input
 */
function convertToJcamp(data, options = {}) {
  const { meta = {}, parserOptions = {} } = options;

  parserOptions.arrayType = 'xyxy';
  parserOptions.keepInfo = true;
  var parsed = xyParser.parseXY(data, parserOptions);
  if (!meta.info) meta.info = {};
  meta.info.header = parsed.info.map((i) => i.value).join('\n');
  let jcamp = creator(parsed.data, meta);
  return jcamp;
}

/**
 * Parse from any supported format in ml-xy-convert
 * @param {*} data - object or array with a set of points
 * @param {object} [meta] - metadata object
 * @return {string} JCAMP of the input
 */
function fromJson(data, meta = {}) {
  const parsed = xyConvert(data, { outputFormat: 'xyxyArray' });
  return creator(parsed, meta);
}

exports['default'] = convertToJcamp;
exports.fromJson = fromJson;
